import { render, staticRenderFns } from "./CertificateTeacher.vue?vue&type=template&id=6bedaa18&"
import script from "./CertificateTeacher.vue?vue&type=script&lang=js&"
export * from "./CertificateTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports